import { EntityTypeEnum, FilterOperation, Organisation, SubscriptionFilter, TradingEntity } from 'api'
import { Locale, Translation } from 'locale'
import React from 'react'
import { useSelector } from 'react-redux'
import { authorisedUserSelector } from 'selectors/connectionSelectors'
import { createAllEntitiesSortedSelector } from 'selectors/entitySelectors'
import { allBuySideOrganisationIdsSelector } from 'selectors/organisationSelectors'
import { isAdminGatewayUserSelector } from 'selectors/userSelectors'
import { ComboboxField } from 'view/components/options'
import {
  getOrganisationIdsBelongingToTradingEntity,
  getOrganisationNameById,
  getSubscriptionFilterValue,
  sortOrganisations
} from '../utils'

interface MyFirmSubscriptionComboboxProps {
  subscriptionFilters: SubscriptionFilter[]
  handleUpdateFilterValue: (fieldName: string, filterOperation: FilterOperation) => (value: any) => void
}

export const MyFirmSubscriptionCombobox: React.FC<MyFirmSubscriptionComboboxProps> = ({ handleUpdateFilterValue, subscriptionFilters }) => {
  const isAdmin = useSelector(isAdminGatewayUserSelector)
  const authorisedUser = useSelector(authorisedUserSelector)
  const allBuySideOrganisationIds = useSelector(allBuySideOrganisationIdsSelector)
  const allOrganisations: Organisation[] = useSelector(createAllEntitiesSortedSelector(EntityTypeEnum.ORGANISATION))
  const allTradingEntities: TradingEntity[] = useSelector(createAllEntitiesSortedSelector(EntityTypeEnum.TRADING_ENTITY))

  const myEntityFilterValue = getSubscriptionFilterValue(subscriptionFilters, 'fundId')
  const organisationIds = myEntityFilterValue
    ? getOrganisationIdsBelongingToTradingEntity(allTradingEntities, myEntityFilterValue)
    : allBuySideOrganisationIds

  return (
    <ComboboxField
      label={Locale.translate(Translation.SC_FILTER_MY_FIRM_EQUALS)}
      dataTestId={'AdvancedDealSubscriptionFilters-Selectbox-MyFirm'}
      canClear={true}
      readOnly={!isAdmin}
      optionKeys={sortOrganisations(organisationIds, allOrganisations)}
      getOption={getOrganisationNameById(allOrganisations)}
      value={isAdmin ? getSubscriptionFilterValue(subscriptionFilters, 'initiatorOrganisationId') : authorisedUser.organisationId}
      onUpdate={handleUpdateFilterValue('initiatorOrganisationId', FilterOperation.EQUALS)}
    />
  )
}
